import { render, staticRenderFns } from "./fifthCaseRow.vue?vue&type=template&id=0df809bc&"
import script from "./fifthCaseRow.vue?vue&type=script&lang=js&"
export * from "./fifthCaseRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports